import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AppPage } from '../types/navigation';
import { ROUTES } from '@/routes/routes';

interface PrivateRouteProps {
  children: ReactNode;
  onNavigate: (page: AppPage) => void;
}

export default function PrivateRoute({ children, onNavigate }: PrivateRouteProps) {
  const { currentUser, loading } = useAuth();

  // If still loading auth state, show nothing
  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // If no user is logged in, redirect to login
  if (!currentUser) {
    onNavigate('login');
    return null;
  }

  // If user is logged in, show the protected content
  return <>{children}</>;
} 